import { useMutation } from '@apollo/client';
import REMOVE_ATL_BID_ON_EVENT from '../queries/removeATLBidOnEventMutation';
import ATL_BID_ON_EVENT from '../queries/atlBidOnEventMutation';
import { showToast } from '@shared/services/toastService';
import { TOAST_MESSAGE_TYPES } from '@shared/constants/toastMessageTypes';

const BID_SUCCESS_MESSAGE = 'Your bid has been received.';
const REMOVE_BID_SUCCESS_MESSAGE = 'Your bid has been removed.';

const useATLEventBidding = () => {
  const [bidOnEvent, { error: bidOnEventError }] = useMutation(ATL_BID_ON_EVENT);

  const [removeBiddingOnEvent, { error: removeBindingOnEventError }] =
    useMutation(REMOVE_ATL_BID_ON_EVENT);

  const handleBidOnEvent = async eventId => {
    await bidOnEvent({ variables: { eventId } });
    showToast(TOAST_MESSAGE_TYPES.SUCCESS, BID_SUCCESS_MESSAGE);
  };

  const handleRemoveBid = async eventId => {
    await removeBiddingOnEvent({ variables: { eventId } });
    showToast(TOAST_MESSAGE_TYPES.SUCCESS, REMOVE_BID_SUCCESS_MESSAGE);
  };

  return {
    handleBidOnEvent,
    handleRemoveBid,
    eventBidError: bidOnEventError || removeBindingOnEventError
  };
};

export default useATLEventBidding;
